/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_viewer = {
    readonly isMultiRequestModalEnabled: boolean | null;
    readonly " $refType": "SharedContactDealerWrapper_viewer";
};
export type SharedContactDealerWrapper_viewer$data = SharedContactDealerWrapper_viewer;
export type SharedContactDealerWrapper_viewer$key = {
    readonly " $data"?: SharedContactDealerWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedContactDealerWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMultiRequestModalEnabled",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiRequestContactModal"
        }
      ],
      "storageKey": "featureFlag(feature:\"multiRequestContactModal\")"
    }
  ]
};
(node as any).hash = '044189fc708c66397149b5d34dd200e6';
export default node;
